// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"424": "372fb92a9cdaa0df","757": "6801a67ef16cf181",}[chunkId] + ".css"
}